import React, { useEffect, useRef } from "react";
import "./ourservices1.css";
import icon1 from "../../../assets/servicesicon1.png";
import icon2 from "../../../assets/serviceicon2.png";
import icon3 from "../../../assets/serviceicon3.png";
import { useTranslation } from "react-i18next";

const OurServices1 = () => {
  const { t } = useTranslation("global");

  // Get translated services
  const services = t("ourServices.section1.services", { returnObjects: true });

  // Reference to the grid container
  const gridRef = useRef(null);

  // Function to scroll to the middle card
  useEffect(() => {
    if (gridRef.current) {
      const middleIndex = Math.floor(services.length / 2);
      const cards = gridRef.current.querySelectorAll(".service-card-services");

      if (cards.length > 0 && cards[middleIndex]) {
        const card = cards[middleIndex];
        const containerWidth = gridRef.current.offsetWidth;
        const cardWidth = card.offsetWidth;
        const cardLeft = card.offsetLeft;
        const scrollPosition = cardLeft - containerWidth / 2 + cardWidth / 2;

        setTimeout(() => {
          gridRef.current.scrollLeft = scrollPosition;
          card.classList.add("active");
        }, 100);
      }
    }
  }, [services.length]);

  return (
    <section className="services-container-section1">
      <h1 className="services-title">{t("ourServices.section1.title")}</h1>
      <div className="ourservices-grid" ref={gridRef}>
        {services.map((service, index) => (
          <article
            className="service-card-services"
            key={index}
            data-index={index}
          >
            <figure className="service-icon-wrapper">
              <img
                className="service-icon"
                src={[icon1, icon2, icon3][index] || "/placeholder.svg"}
                alt={`${service.title} icon`}
              />
            </figure>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default OurServices1;
